
import React from 'react';

interface IProps {
  style?: any;
  
}

export const StartIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="99" height="89" viewBox="0 0 99 89" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M49.5 0L61.0625 33.8582L98.4794 33.8582L68.2085 54.7837L79.7709 88.6418L49.5 67.7163L19.2291 88.6418L30.7915 54.7837L0.520588 33.8582L37.9375 33.8582L49.5 0Z" fill="#dee2eb"/>
</svg>

    
  )
}
